import React,{useState} from 'react';
import { Button, TextField, Card ,Box} from "@material-ui/core";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import {useStyles} from '../../styles/styles';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import logo from "../../logo.png";
import { Redirect } from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';

import {LoginAction} from '../../redux/actions/AuthActions';

import {useHistory,Link} from 'react-router-dom'; 
const styles = {
  root: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none',
    paddingTop: '25px',
    color: '#FFFFFF'
  },
  centerItemLogin: {
    flex: "auto",
    top: "15%",
    position: "relative",
    left: "33.33%",
    right: "33.33%",
    width: "33.33%",
    '@media (max-width: 500px)': { 
      left: "5%",
      right: "5%",
      width: "90%",
    },
    marginBottom: "10%",
    marginTop: "10%",
  },
  cardItem: {
    paddingTop: "30px",
  },
  primary: {
    color: "#67a8e4",
  },
  customFail: {
    color: "#ef5350",
  },
  customSuccess: {
    color: "#4caf50",
  },
   fullWidth: {
    width: "80%",
    marginBottom: "25px",
    marginTop: "20px",
  },
  customButton: {
    marginTop: "15px",
    marginBottom: "30px",
    backgroundColor: "#67a8e4",
    textTransform: "Capitalize",
    clear: "both",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "30px",
    paddingRight: "30px",

    "&:hover": {
      background: "#67a8e4",
    },
  },
  customButtonLeft: {
    float: "right",
    marginRight: "10%",
  },
  linkContainer: {
    marginBottom: "20px",
  },
  customClear: {
    position: "relative",
    top: "40%",
    clear: "both",
    color: "#404346",
    fontSize: "16px",
  },
  customLinkDark: {
    color: "#404346",
    textDecoration: "none",
  },
   roundIcon: {
    backgroundColor: "white",
    borderRadius: "50%",
    color: "#67a8e4",
  },
  customLink: {
    color: "#fff",
    textDecoration: "none",
  },
  link_label: {
    color: '#fff'
  }
  
  
}



function LoginComponent(props) {
  
  const history = useHistory();
  const { classes } = props;
  const dispatch = useDispatch();

  const authResponse = useSelector(state=>state.userAuth.authResponse);


  const [fields, setState] = useState({
    email: "",
    password: "",
  });
  const [errorFlagLogin, setErrorFlagLogin] = useState(false)

  const handleFieldChange = e => {
    setState({
        ...fields,
        [e.target.id] : e.target.value
    })
}

    const UserLogin = (e) => {
        e.preventDefault();
        
        
      dispatch(LoginAction(fields, history));
        if (authResponse.success === false) {
          setErrorFlagLogin(true)
        }
      };
      
      

      
    return (
        <div>
            <div className={classes.centerItemLogin}>
        <Card className={classes.cardItem}>
        <Box
                    component="img"
                            sx={{
                            height: 70,
                            width: 400,
                            minHeight: { xs: 40, md: 70 },
                            maxHeight: { xs: 40, md: 167 },
                            maxWidth: { xs: 233, md: 400 },
                            minWidth:{ xs: 233, md: 400 },
                            }}
                    alt="DOED"
                    src={logo}
                />
          <h2 >
          <b className={classes.primary}>
            Client Login</b>
          </h2>

            {(authResponse.success == false)?<div className={classes.customFail}>
              {
                Object.keys(authResponse.message).map((errorKey) => (
                  authResponse.message[errorKey].map((errorValue, index) => (
                    (errorKey === 'password_error' || errorKey === 'email_error' || errorKey === 'password_email_error')?
                    <div key={index}> {errorValue}
                      <br />
                    </div>
                 :null
               

                  ))

                ))
              }
          </div>:<div className={classes.customSuccess}>{authResponse.message}</div>}
          <form onSubmit={UserLogin}>
            <div>
              <TextField
                type="email"
                className={classes.fullWidth}
                required
                margin="normal"
                variant="outlined"
                label="Email"
                id="email"
                value={fields.email}
                onChange={handleFieldChange}
              />
            </div>

            <div>
              <div>
                <TextField
                  className={classes.fullWidth}
                  label="Password"
                  type="password"
                  margin="normal"
                  variant="outlined"
                  required
                  id="password"
                  value={fields.password}
                  onChange={handleFieldChange}
                />
              </div>

              <div>
                <Button
                  type="submit"
                  className={[ classes.customButton,classes.customButtonLeft ].join(' ')}
                  variant="contained"
                  color="primary"
                >
                  <b>Login</b>
                </Button>
                <br />
                <div className={[classes.linkContainer, classes.customClear
].join(' ')}>
               
                  <Link to="/user/register" className={classes.customLinkDark}> Sign Up</Link>
                </div>
              </div>

              <div className={classes.linkContainer}>
                  <Link to="/" className={classes.customLink}> <Button startIcon={<ArrowBackRounded className={classes.roundIcon} />} className={[classes.customButton, classes.link_label]}> Back To Home Page</Button></Link> 
              </div>

              <div></div>
            </div>
          </form>
        </Card>
      </div>
        </div>
    )
}

export default withStyles(styles)(LoginComponent);
